import types from '../types';

const trades = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_TRADES_START:
      return { ...state, loading: true };

    case types.GET_TRADES_SUCCESS:
      return { ...state, data: payload, loading: false };

    case types.GET_TRADES_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default trades;
